module.exports = __webpack_public_path__ + "img/icon_check_w.c91483e3.svg";